module.exports = __webpack_public_path__ + "img/f_r1_moongoddess.e5e1a562.jpg";